export default {
  BACK: 'Kembali',
  EXIT: 'Keluar',
  NEXT: 'Selanjutnya',
  YES: 'Ya',
  NO: 'Tidak',
  CANCEL: 'Batal',
  APPLY: 'Terapkan',
  EDIT: 'Ubah',
  PROCESS: 'Proses',
  SAVE: 'Simpan',
  DELETE: 'Hapus',
  CREATED_BY: 'Dibuat Oleh',
  UPDATED_BY: 'Diubah Oleh',
  STATUS: 'Status',
  SUBMIT: 'Submit',
  SAVE_AS_DRAFT: 'Save Draft',
  NUMBER: 'No',
  DATE: 'Tanggal',
  FROM_DATE: 'Dari Tanggal',
  NOTE: 'Catatan',
  ACTION: 'Aksi',
  VIEW_DETAIL: 'Lihat Detail',
  DETAIL: 'Detail',
  NAME: 'Nama',
  WARNING: 'Perhatian',
  ADD: 'Tambah',
  SEND: 'Kirim',
  UPDATE: 'Update',
  CLOSE: 'Tutup',
  CREATE: 'Buat',
  CHOOSE: 'Pilih',
  LOADING_TEXT: 'Loading... Please wait',
  ERROR_MESSAGE: 'Terjadi Kesalahan',
  DOWNLOAD: 'Download',
  SEARCH: 'Cari',
  commonTablePagination: (page, length, size, totalEntry) => {
    if (length >= 1) {
      if (page === 1 && totalEntry <= size) {
        return (`1 - ${length} dari ${totalEntry}`);
      }
      if (page === 1) {
        return (`1 - ${size} dari ${totalEntry}`);
      }
      if (page >= 2) {
        const from = (page - 1) * size + 1;
        const to = from + (length - 1);
        return (`${from} - ${to} dari ${totalEntry}`);
      }
    }
    return '';
  },
};
